<template>
  <div class="annotation">
    <el-tooltip class="item" effect="dark"  placement="right">
      <div slot="content" style="white-space:normal;width: 300px;">{{ content }}</div>
      <span class="el-icon-warning-outline" style="color: red;margin-left: 12px;"></span>
      </el-tooltip>
  </div>
</template>

<script >
export default {
  props:{
    content:{
      type:String,
      default:''
    }
  }
}
</script>

<style scoped>
.item{
  cursor: pointer;
  font-size: 15px;
}
.annotation{
  display: inline-block;
}
</style>